import { render } from "./GrayInput.vue?vue&type=template&id=13a8bd53&scoped=true&ts=true"
import script from "./GrayInput.vue?vue&type=script&lang=ts"
export * from "./GrayInput.vue?vue&type=script&lang=ts"

import "./GrayInput.vue?vue&type=style&index=0&id=13a8bd53&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a8bd53"]])

export default __exports__